import React from 'react';
import { connect } from 'react-redux';
import { getProject } from 'project/ducks/project';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import { isCollaborator } from 'project/utils';
import Updates from 'project/components/brief/updates';

const getEditorLabel = (isOwner, isCollab) => {
  if (!(isOwner || isCollab)) {
    return (
      <div>
        <h4>Ask the client</h4>
      </div>);
  }

  if (isOwner || isCollab) {
    return (
      <div>
        <h4>Share an update</h4>
      </div>);
  }

  return '';
}

const mapStateToProps = (state) => {
  const project = getProject(state);
  const user = state.user.profile_data;
  const isOwner = user.id && user.id === project.client;
  const isCollab = isCollaborator(project);

  /* only authenticated users can post and project can't be completed or cancelled */
  let canPost = !!user.id && !['completed', 'cancelled'].includes(project.status);
  /* if project is not 1-1, only the project owner or collaborators can post messages */
  if (!project.is_one_to_one) {
    canPost = canPost && (isOwner || isCollab);
  }

  /* if 1-1, use default message for empty timeline */
  const emptyLabel = !project.is_one_to_one? "There are no client updates at this time." : undefined;

  /* if project is 1-1, selected creative can only see messages after she was selected */
  const startAt = (
    (project.is_one_to_one && user.id == project.one_to_one_creative)?
    project.one_to_one_creative_updated_at : null
  );

  return {
    project,
    canPost,
    emptyLabel,
    startAt,
    canAttach: isOwner || isCollab,
    canPostInternal: isOwner || isCollab,
    editorLabel: getEditorLabel(isOwner, isCollab),
    editorActionLabel: !(isOwner || isCollab)? 'Ask Question' : 'Send',
  }
}

export default connect(mapStateToProps, {
  fetchMessagesIfNeeded
})(Updates);



// WEBPACK FOOTER //
// ./project/containers/brief_updates.jsx